module.exports = __webpack_public_path__ + "static/media/danxuanfuxuan.dab72da5.png";


//////////////////
// WEBPACK FOOTER
// ./src/inviteNewUsers/share/images/danxuanfuxuan.png
// module id = 1152
// module chunks = 0